import splitbee from "@splitbee/web";
import posthog from "posthog-js";

export const logEvent = (event: string) =>  {
  splitbee.track(event);
  logEventPosthog(event, {});
}

const logEventPosthog = (event: string, properties: any) => {
  posthog.capture(
    event, 
    properties
  )
}

export default () => { return null; }